import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Row, Col, Input } from "reactstrap";
import DropdownList from "react-widgets";
import { toast } from "react-toastify";
import { useState } from "react";
import Moment from "react-moment";
import moment from "moment-timezone";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";

function ListManualEntriesModal({ show, toggle, manualEntries, setManualEntries, loadManualEntries, load }) {
    const usedOptions = [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 2 },
    ];
    const [filter, setFilter] = useState({
        usedValue: 1
    });
    const [formEntries, setFormEntries] = useState([{
        date: new Date().toISOString().split("T")[0],
        description: "",
        amount: 0,
        requiredAmount: false,
    }]);
    const editManualEntry = (index) => {
        manualEntries[index].editable = true;
        setManualEntries([...manualEntries]);
    };
    const saveManualEntry = (index) => {
        let findManualEntry = manualEntries.find((entry, i) => i === index);
        PostApiWithAuthorizationAction(`manual-entries/update/${findManualEntry.id}`, {
            date: findManualEntry.createdAt,
            description: findManualEntry.description,
            amount: findManualEntry.amount
        }).then((res) => {
            loadManualEntries();
            load();
        }).finally(() => {
            manualEntries[index] = findManualEntry;
            manualEntries[index].createdAt = moment(findManualEntry.createdAt).tz("America/Los_Angeles").toDate();
            manualEntries[index].editable = false;
            setManualEntries([...manualEntries]);
        });
    };
    const deleteManualEntry = (id) => {
        console.log("Deleting manual entry with id:", id);
        // Implement the delete logic here
        PostApiWithAuthorizationAction("manual-entries/delete", {
            id: id
        }).then((res) => {
            // remove the deleted manual entry from the list
            const _manualEntries = manualEntries.filter((entry) => entry.id !== id);
            setManualEntries([..._manualEntries]);
        }).finally(() => {
            loadManualEntries();
            load();
        });
    };
    const renderForm = () => {
        return formEntries.map((credit, index) => (
        <tr key={index}>
            <td>
                <Input
                    bsSize="lg"
                    type="date"
                    value={credit.date}
                    onChange={(e) => {
                    const newCredits = [...formEntries];
                    newCredits[index].date = e.target.value;
                    setFormEntries(newCredits);
                    }}
                />
            </td>
            <td>
                <Input
                    placeholder="Description"
                    value={credit.description}
                    style={{ width: "250px" }}
                    onChange={(e) => {
                    const newCredits = [...formEntries];
                    newCredits[index].description = e.target.value;
                    setFormEntries(newCredits);
                    }}
                />
            </td>
            <td>
                <Input
                    placeholder="Amount"
                    type="number"
                    value={credit.amount}
                    style={{ width: "100px", borderColor: credit.requiredAmount ? "red" : "" }}
                    onChange={(e) => {
                    const newCredits = [...formEntries];
                    newCredits[index].amount = parseInt(e.target.value);
                    setFormEntries(newCredits);
                    if (newCredits[index].amount === 0) {
                        newCredits[index].requiredAmount = true;
                    } else {
                        newCredits[index].requiredAmount = false;
                    }
                    }}
                />
            </td>
            <td style={{ verticalAlign: "top" }}>
                {(index === formEntries.length - 1) && (
                <Button
                    className="icon-cross"
                    id="add-item"
                    color="primary"
                    onClick={(e) => {
                    addItemsHandler(index);
                    }}
                >
                    <i class="fas fa-plus-square"></i>
                </Button>
                )}
                {(formEntries.length > 1)&& (
                <Button
                    id="remove"
                    className="icon-cross"
                    color="danger"
                    title="remove"
                    onClick={() => {
                    removeRowInItem(index);
                    }}
                >
                    <i className="fas fa-times"></i>
                </Button>)}
            </td>
        </tr>
        ));
    };

    const addItemsHandler = (index) => {
        let findCredit = formEntries.find((credit, i) => i === index);
        let amount = parseFloat(findCredit.amount);
        console.log(amount);
        if (isNaN(amount) || amount === 0) {
        findCredit.requiredAmount = true;
        formEntries[index] = findCredit;
        setFormEntries([...formEntries]);
        } else {
        setFormEntries([...formEntries, {
            date: new Date().toISOString().split("T")[0],
            description: "",
            amount: 0,
            requiredAmount: false,
        }]);
        }
    };

    const removeRowInItem = (index) => {
        const newCredits = [...formEntries];
        newCredits.splice(index, 1);
        setFormEntries(newCredits);
    };

    const submitHandler = () => {
        console.log("Submitting credits:", formEntries);
        //
        let allNotValid = formEntries.some(credit => isNaN(credit.amount) || credit.amount === 0);
        if (allNotValid) {
        toast.error("Some credits are not valid");
        return;
        }
        // You can add your API call or further processing logic here for the valid credits
        PostApiWithAuthorizationAction("common/create-new-manual-entry", {
            entries: formEntries
        }).then((res) => {
            setFormEntries([{
                date: new Date().toISOString().split("T")[0],
                description: "",
                amount: 0,
                requiredAmount: false,
            }]);
            loadManualEntries();
            load();
        });
    };
    const renderHTML = () => {
        return manualEntries.map((entry, index) => (
            <tr key={index}>
                <td>
                    {entry.editable ? (
                        <Input
                            bsSize="sm"
                            type="date"
                            value={moment(entry.createdAt).format("YYYY-MM-DD")}
                            onChange={(e) => {
                                const newManualEntries = [...manualEntries];
                                newManualEntries[index].createdAt = e.target.value;
                                setManualEntries([...newManualEntries]);
                            }}
                        />
                    ) : (
                        <Moment format="MM/DD/YY" tz="America/Los_Angeles">
                            {entry.createdAt.toString().length === 10
                                ? new Date(entry.createdAt * 1000)
                                : new Date(entry.createdAt)}
                        </Moment>
                    )}
                </td>
                <td>
                    {entry.editable ? (
                        <Input
                            placeholder="Description"
                            value={entry.description}
                            style={{ width: "250px" }}
                            onChange={(e) => {
                            const newManualEntries = [...manualEntries];
                            newManualEntries[index].description = e.target.value;
                            setManualEntries([...newManualEntries]);
                            }}
                        />
                    ) : (
                        entry.description
                    )}
                </td>
                <td>
                    {entry.editable ? (
                        <Input
                            placeholder="Amount"
                            type="number"
                            value={entry.amount}
                            style={{ width: "100px", borderColor: entry.requiredAmount ? "red" : "" }}
                            onChange={(e) => {
                            const newManualEntries = [...manualEntries];
                            newManualEntries[index].amount = parseInt(e.target.value);
                            setManualEntries([...newManualEntries]);
                            if (newManualEntries[index].amount === 0) {
                                newManualEntries[index].requiredAmount = true;
                            } else {
                                newManualEntries[index].requiredAmount = false;
                            }
                            }}
                        />
                    ) : (
                        entry.amount
                    )}
                </td>
                <td>
                    {entry.editable ? (
                        <Button
                            color="success"
                            size="sm"
                            onClick={() => {
                                saveManualEntry(index);
                            }}>
                            <i className="fas fa-save"></i>
                        </Button>
                    ) : (
                        <>
                            <Button
                                color="primary"
                                size="sm"
                                onClick={() => {
                                    editManualEntry(index);
                                }}>
                                <i className="fas fa-edit"></i>
                            </Button>
                            <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                    if (window.confirm('Are you sure you want to delete this credit?')) {
                                        deleteManualEntry(entry.id);
                                    }
                                }}>
                                <i className="fas fa-trash"></i>
                            </Button>
                        </>
                    )}
                </td>
            </tr>
        ));
    };
    return (
        <Modal isOpen={show} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Manual Entries</ModalHeader>
            <ModalBody>
                <h2>Add Manual Entries</h2>
                <Row>
                    <Col md="3" lg="6" xl="3">
                        <Table className="desc-table" borderless>
                            <thead>
                            <tr>
                                <td>Date</td>
                                <td>Description</td>
                                <td>Amount</td>
                                <td></td>
                            </tr>
                            </thead>
                            <tbody>{renderForm()}</tbody>
                            <tfoot>
                                <td colSpan={3}></td>
                                <td style={{textAlign: 'left'}}>
                                    <Button
                                        id="add-btn"
                                        color="primary"
                                        size="sm"
                                        onClick={(e) => {
                                            submitHandler();
                                        }}
                                    >Add</Button>
                                </td>
                            </tfoot>
                        </Table>
                    </Col>
                </Row>
                <h2>History</h2>
                <div className="history-table">
                    <div className="table-filter-right">

                    </div>
                    <Table
                        className="ticket-table table-listing table table-bordered table-striped"
                        borderless>
                        <thead>
                        <tr>
                            <td>Date</td>
                            <td>Description</td>
                            <td>Amount</td>
                            <td>Actions</td>
                        </tr>
                        </thead>
                        <tbody>{renderHTML()}</tbody>
                    </Table>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Close</Button>
            </ModalFooter>
        </Modal>
    );
}

export default ListManualEntriesModal;